import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { ConfluenceCardIllustrationDark } from '../assets/ConfluenceCardIllustrationDark';

import { ConfluenceCardIllustrationLight } from '../assets/ConfluenceCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const ConfluenceOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <ConfluenceCardIllustrationLight />,
		componentDark: <ConfluenceCardIllustrationDark />,
	};
	return (
		<CarouselBaseCard
			messages={{ ...confluenceMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const confluenceMessages = defineMessages({
	heading: {
		defaultMessage: 'Write docs with Confluence',
		description: 'Heading for the confluence onboarding card',
		id: 'townsquare.twc-onboarding-widget.confluence-card.heading',
	},
	description: {
		defaultMessage: 'Create a knowledge bank available to everyone in your team.',
		description: 'Description for the confluence onboarding card',
		id: 'townsquare.twc-onboarding-widget.confluence-card.description',
	},
	cta: {
		defaultMessage: 'Try Confluence',
		description: 'CTA text for the confluence onboarding card',
		id: 'townsquare.twc-onboarding-widget.confluence-card.cta',
	},
});
